import React from 'react'
import user1 from './images/user1.png'
import user2 from './images/user2.png'
import user3 from './images/bp.png'
import user4 from './images/sanket.png'
import './OurTeam.css'

const TEAM = [
  { img: user3, name: 'ANIL WARE',     role: 'Manager'          },
  { img: user4, name: 'SANKET GOLE',   role: 'Accountant'       },
  { img: user1, name: 'SAHIL SHELAR',  role: 'Field Technician' },
  { img: user2, name: 'AKSHAY SHELKE', role: 'Field Technician' },
]

const OurTeam = () => {
  return (
    <section name='OurTeam' className='team' aria-label="Our Team section">
      <div className="container">

        <div className="team__header reveal">
          <p className="team__eyebrow">The People Behind GetNet</p>
          <h2 className="team__heading">Our <span className="team__heading-accent">Team</span></h2>
          <span className="section-line" style={{ margin: '0.75rem auto 0' }} />
        </div>

        <div className="team__grid reveal-stagger">
          {TEAM.map((member, i) => (
            <div className="team__card reveal" key={member.name} style={{ transitionDelay: `${i * 0.1}s` }}>
              <div className="team__card-glow" aria-hidden="true" />
              <div className="team__avatar-wrap">
                <img
                  src={member.img}
                  alt={`${member.name} — ${member.role}`}
                  className="team__avatar"
                />
              </div>
              <div className="team__card-body">
                <p className="team__member-name">{member.name}</p>
                <p className="team__member-role">{member.role}</p>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  )
}

export default OurTeam
